import React, {Component} from 'react'

import PaperBlock from './../../ui/PaperBlock'
import BottomButton from './../../ui/BottomButton'
import Screen from './../../ui/Screen'
import ErrorMessageDialog from './../../ui/ErrorMessageDialog'

import ControlPanel from "./EditTemplateItemsScreen/ControlPanel"
import ItemsList from "./EditTemplateItemsScreen/ItemsList"
import Typography from '@material-ui/core/Typography'

import SelectItemDialog from "./../../inventory/SelectItemDialog"
import SetItemAmountDialog from "./EditTemplateItemsScreen/SetItemAmountDialog"
import DeleteTemplateItemDialog from "./EditTemplateItemsScreen/DeleteTemplateItemDialog"

import Cookie from "./../../Cookie"
import {config} from "./../../config"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <EditTemplateItemsScreen template onClose = {}/>
 */

class EditTemplateItemsScreen extends Component {

	state = {
		template: undefined,
		selected: undefined,
		dialog: undefined,
	}

	constructor(props) {
		super(props)
		this.handleAttachItem = this.handleAttachItem.bind(this)
		this.handleEditItemAmount = this.handleEditItemAmount.bind(this)
		this.handleDetachItem = this.handleDetachItem.bind(this)
		this.updateSelected = this.updateSelected.bind(this)
		this.handleError = this.handleError.bind(this)
		this.handleClickItem = this.handleClickItem.bind(this)
		this.handle_onMoveItemUp = this.handle_onMoveItemUp.bind(this)
		this.handle_onMoveItemDown = this.handle_onMoveItemDown.bind(this)
	}

	updateSelected() {
		if (this.state.template && this.state.selected) {
			for(let item of this.state.template.items) {
				if (this.state.selected.id === item.id) {
					return item
				}
			}
		}
	}

	componentDidMount() {
		this.setState({
			template: this.props.template
		})
	}

	getTemplate(templateId) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("GET", config.restApiHost + `/show/template/${templateId}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Ну удалось получить шаблон")
					}
				}
			}
			xhr.send()
		})
	}

	update() {
		return new Promise((resolve, reject) => {
			if (this.props.template) {
				this.getTemplate(this.props.template.id).then(template => {
					this.setState({
						template: template
					}, resolve(template))
				}, reject)
			} else {
				resolve(this.props.template)
			}
		})
	}

	attachItem(template, item, amount, repeat) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("POST", config.restApiHost + `/show/template/${template.id}/item/${item.id}/${amount}/repeat/${repeat}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Ну удалось добавить предмет")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	updateItemAmount(template, item, amount) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/template/${template.id}/item/${item.id}/amount/${amount}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Ну удалось изменить кол-во предметов")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	updateItemRepeat(template, item, repeat) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/template/${template.id}/item/${item.id}/repeat/${repeat}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Ну удалось изменить режим добавления")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	detachItem(template, item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("DELETE", config.restApiHost + `/show/template/${template.id}/item/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Ну удалось удалить предмет")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	handleError(errorMessage) {
		this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {() => {
					this.update().then(() => {
						this.setState({
							dialog: undefined
						})
					}, this.handleError)
				}}
			/>
		})
	}

	handleAttachItem(template) {
		this.setState({
			dialog: <SelectItemDialog
				onSelectItem = {item => {
					this.setState({
						dialog: <SetItemAmountDialog
							template = {template}
							item = {item}
							amount = {1}
							repeat = '1'
							onSetAmount = {(template, item, amount, repeat) => {
								this.attachItem(template, item, amount, repeat).then(template => {
									this.setState({
										template: template,
										dialog: undefined,
										selected: this.updateSelected(),
									})
								}, this.handleError)
							}}
							onCancel = {() => {
								this.setState({
									dialog: undefined
								})
							}}
						/>
					})
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleEditItemAmount(template, item) {
		this.setState({
			dialog: <SetItemAmountDialog
				template = {template}
				item = {item}
				amount = {item.amount}
				repeat = {item.repeat}
				onSetAmount = {(template, item, amount, repeat) => {
					this.updateItemAmount(template, item, amount).then(template => {
						this.updateItemRepeat(template, item, repeat).then(template => {
							this.setState({
								template: template,
								dialog: undefined,
								selected: this.updateSelected(),
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleDetachItem(template, item) {
		this.setState({
			dialog: <DeleteTemplateItemDialog
				template = {template}
				item = {item}
				onDeleteTemplateItem = {(template, item) => {
					this.detachItem(template, item).then(template => {
						this.setState({
							template: template,
							dialog: undefined,
							selected: this.updateSelected(),
						})
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleClickItem(item) {
		if (this.state.selected) {
			if (this.state.selected.id === item.id) {
				this.handleEditItemAmount(this.state.template, item, item.amount)
			}
		}
		this.setState({
			selected: item
		})
	}

	moveItemUp(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/template/moveup/item/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Операция не удалась")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send()
		})
	}

	moveItemDown(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/template/movedown/item/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Операция не удалась")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send()
		})
	}

	handle_onMoveItemUp(template, item) {
		this.moveItemUp(item).then(() => {
			this.update()
		})
	}

	handle_onMoveItemDown(template, item) {
		this.moveItemDown(item).then(() => {
			this.update()
		})
	}

	render() {

		return <Screen>

			{this.state.dialog}

			<PaperBlock style = {{display: "flex", flexDirection: "column", alignItems: "center"}}>
				<Typography>Шаблон: {this.state.template ? this.state.template.name : ""}</Typography>
			</PaperBlock>


			<ControlPanel
				template = {this.props.template}
				selected = {this.state.selected}
				onAttachItemClick = {this.handleAttachItem}
				onEditItemAmountClick = {this.handleEditItemAmount}
				onDetachItemClick = {this.handleDetachItem}
				onMoveItemUp = {this.handle_onMoveItemUp}
				onMoveItemDown = {this.handle_onMoveItemDown}
			/>

			<ItemsList
				items = {this.state.template ? this.state.template.items : []}
				selected = {this.state.selected}
				onClickItem = {this.handleClickItem}
			/>

			<div style = {{display: "flex", justifyContent: "flex-end",width: "100%"}}>
				<BottomButton
					variant = "contained"
					color = "default"
					onClick = {e => {
						e.stopPropagation()
						this.props.onClose()
					}}
				>Выход</BottomButton>
			</div>

		</Screen>

	}

}

export default withStyles(theme => ({

}))(EditTemplateItemsScreen)
